import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './calendar-item.types';

export const calendarItemSelectors = {
  ...generateResourceSelectors<types.ICalendarItem>((state) => state.resource.calendarItem),
};
